// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"a6a5320f","125":"f281cddd","179":"3526a630","207":"1aa4a2c1","330":"2dd6b0c9","594":"12a42d8c"}[chunkId] + ".js";
};